export enum HeaderVariant {
  Default = 'default',
  Solid = 'solid',
}
